export default __webpack_public_path__ + "static/img4-e2259cfeaf758e14448d426f9bfe54d9.webp";